import BorderBox from 'components/shared/generic/borderBox/BorderBox';
import DetailRow from 'components/shared/generic/detailRow/DetailRow';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import dayjs from 'dayjs';
import useTranslate from 'lib/languages/useTranslate';
import { formatSortCode, getTellMoneyFrequencyText } from 'lib/utils';
import {
    ConsentPaymentAccountType,
    ConsentPaymentInformation,
    ConsentSchemeName,
} from 'lib/type';

interface PaymentDetailsProps {
    paymentInformation: ConsentPaymentInformation;
    accountType: ConsentPaymentAccountType;
}

const TellGatewayPaymentDetails = ({
    paymentInformation,
    accountType,
}: PaymentDetailsProps) => {
    const translate = useTranslate('consent');
    const account =
        accountType === ConsentPaymentAccountType.CREDITOR
            ? paymentInformation?.CreditorAccount
            : paymentInformation?.DebtorAccount;

    const formattedFirstPaymentDate = paymentInformation?.FirstPaymentDateTime
        ? dayjs(paymentInformation.FirstPaymentDateTime).format('DD/MM/YYYY')
        : undefined;

    return (
        <BorderBox className="payment-details">
            <Typography tag="h1">
                {translate('paymentDetails.headerText')}
            </Typography>
            <DetailRow
                label={translate('paymentDetails.identification')}
                value={account?.Identification}
            />
            <DetailRow
                label={translate('paymentDetails.payee')}
                value={account?.Name}
            />
            {account?.SchemeName ===
                ConsentSchemeName.SORT_CODE_ACCOUNT_NUMBER && (
                <>
                    <DetailRow
                        label={translate('paymentDetails.payeeAccount')}
                        value={account?.Identification.substring(6)}
                    />
                    <DetailRow
                        label={translate('paymentDetails.payeeSortcode')}
                        value={formatSortCode(
                            account?.Identification.substring(0, 6),
                        )}
                    />
                </>
            )}
            <DetailRow
                label={translate('paymentDetails.amount')}
                value={paymentInformation?.InstructedAmount?.Amount}
            />
            <DetailRow
                label={translate('paymentDetails.currency')}
                value={paymentInformation?.InstructedAmount?.Currency}
            />
            <DetailRow
                label={translate('paymentDetails.firstPaymentDateTime')}
                value={formattedFirstPaymentDate}
            />
            <DetailRow
                label={translate('paymentDetails.firstPaymentAmount')}
                value={paymentInformation?.FirstPaymentAmount?.Amount}
            />
            <DetailRow
                label={translate('paymentDetails.firstPaymentCurrency')}
                value={paymentInformation?.FirstPaymentAmount?.Currency}
            />
            <DetailRow
                label={translate('paymentDetails.frequency')}
                value={getTellMoneyFrequencyText(
                    paymentInformation?.Frequency,
                    translate,
                )}
            />
            <DetailRow
                label={translate('paymentDetails.reference')}
                value={paymentInformation?.RemittanceInformation?.Reference}
            />
            <DetailRow
                label={translate('paymentDetails.reference')}
                value={paymentInformation?.Reference}
            />
        </BorderBox>
    );
};

export default TellGatewayPaymentDetails;
